import { COST_BOM_DEMO_STRINGS } from '~/widgets/CostBomDemo/strings'

export function HeroHead() {
  return (
    <div className="hero-head">
      <h1 className="hero-h1">
        <span className="hero-h1-grad">
          {COST_BOM_DEMO_STRINGS.titleGradient}
        </span>
        {COST_BOM_DEMO_STRINGS.titleSuffix}
      </h1>
      <p className="hero-sub">{COST_BOM_DEMO_STRINGS.subtitle}</p>
    </div>
  )
}
